import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
// Documentation: https://www.npmjs.com/package/react-paginate

import styles from './Pagination.module.css';

const PAGE_RANGE_DISPLAYED = 3;
const MARGIN_PAGES_DISPLAYED = 1;

// pageCount: the total number of pages
// currentPage: the selected page number
// onPageChange: the method to call when a page is clicked
const Pagination = ({
  pageCount,
  currentPage,
  containerClassName,
  onPageChange,
}) => (
  <div className={containerClassName}>
    <ReactPaginate
      pageCount={pageCount}
      forcePage={currentPage}
      pageRangeDisplayed={PAGE_RANGE_DISPLAYED}
      marginPagesDisplayed={MARGIN_PAGES_DISPLAYED}
      previousLabel={<i className="fal fa-angle-left" />}
      nextLabel={<i className="fal fa-angle-right" />}
      containerClassName={styles.container}
      activeClassName={styles.active}
      pageClassName={styles.page}
      previousClassName={styles.previous}
      nextClassName={styles.next}
      disabledClassName={styles.disabled}
      breakClassName={styles.break}
      onPageChange={onPageChange}
    />
  </div>
);

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  containerClassName: PropTypes.string,
  onPageChange: PropTypes.func.isRequired,
};

Pagination.defaultProps = {
  containerClassName: '',
};

export default Pagination;
